import { MesfModal } from "@dexteel/mesf-core";
import { Box, Button } from "@mui/material";

import { DrawingViewer } from "@/pages/products/components/DrawingViewer";

type Props = {
	open: boolean;
	title: string;
	path: string | null;
	onClose: () => void;
};

export const WeldTestPhotoModal = ({ open, title, path, onClose }: Props) => (
	<MesfModal
		id="modal-weld-test-photo"
		title={title.toUpperCase()}
		open={open}
		handleClose={onClose}
		maxWidth="md"
	>
		<MesfModal.Content style={{ padding: 0 }}>
			<Box sx={{ height: "70vh" }}>
				<DrawingViewer drawingPath={path} />
			</Box>
		</MesfModal.Content>
		<MesfModal.Actions style={{ padding: "12px 24px" }}>
			<Button variant="contained" color="inherit" onClick={onClose}>
				Close
			</Button>
		</MesfModal.Actions>
	</MesfModal>
);
